
import React, { useState } from 'react';
import Sidebar from '../sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import { BsBell, BsMoon, BsSun } from 'react-icons/bs';
import { FaUserCircle } from 'react-icons/fa';
import {useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

export default function AdminLayout() {
   const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);

    const userData = JSON.parse(localStorage.getItem('user'));
  const name = userData?.user?.name || 'Guest';

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle('bg-dark', !darkMode);
    document.body.classList.toggle('text-light', !darkMode);
  };

  return (
    <div className="d-flex font_family">
      <Sidebar />
      <div className="p-4" style={{ flex: 1, overflowX: 'auto' }}>

        {/* Header */}
        <div
          className="d-flex justify-content-between align-items-center px-4 py-3 shadow-sm mb-3 background_color"
          style={{
            color: '#fff',
            borderRadius: '10px',
          }}
        >
          <h5 className="mb-0 fs-4 fw-semibold">Admin Dashboard</h5>

          {/* Right controls */}
          <div className="d-flex align-items-center" style={{ gap: '20px' }}>
            {/* Notification */}
            <button
              className="btn position-relative text-white p-0"
              title="Notifications"
              style={{ lineHeight: 1 }}
            >
              <BsBell size={18} />
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{ fontSize: '10px' }}
              >
                3
              </span>
            </button>

            {/* Theme Toggle */}
            <button
              className="btn text-white p-0"
              onClick={toggleDarkMode}
              title="Toggle Theme"
              style={{ lineHeight: 1 }}
            >
              {darkMode ? <BsSun size={18} /> : <BsMoon size={18} />}
            </button>

            {/* Profile Dropdown */}
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center text-white p-0"
                id="dropdownUser"
                data-bs-toggle="dropdown"
                style={{ gap: '6px' }}
              >
                <FaUserCircle size={20} />
                <span className="fw-semibold" style={{ fontSize: '14px' }}>{name}</span>
              </button>
              <ul
                className={`dropdown-menu dropdown-menu-end ${
                  darkMode ? 'bg-dark text-light' : ''
                }`}
                aria-labelledby="dropdownUser"
              >
                <li><a className="dropdown-item" href="#">My Profile</a></li>
                <li><a className="dropdown-item" href="#">Settings</a></li>

                  <li><hr className="dropdown-divider" /></li>
                <li><a className="dropdown-item" style={{cursor:"pointer"}}  onClick={handleLogout}>Logout</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Page Content */}
        <Outlet />
      </div>
    </div>
  );
}
